import DemandListStore        from 'stores/DemandListStore';
import PrivateLayoutStore     from './PrivateLayoutStore';
import ShowDashboardStore     from './ShowDashboardStore';
import StandDashboardStore    from './StandDashboardStore';
import StandDocumentListStore from './StandDocumentListStore';
import StandListStore         from './StandListStore';

export const demandListStore = new DemandListStore();
export const privateLayoutStore = new PrivateLayoutStore();
export const showDashboardStore = new ShowDashboardStore();
export const standDashboardStore = new StandDashboardStore();
export const standDocumentsListStore = new StandDocumentListStore();
export const standListStore = new StandListStore();

const stores = {
  demandListStore,
  privateLayoutStore,
  showDashboardStore,
  standDashboardStore,
  standDocumentsListStore,
  standListStore,
};

export default stores;
